import { generateArray } from './util/util';

export const ALIGNER_CHECKLISTS = generateArray(17).map(id => ({
  id,
  route: `/tx-plan/${id}`,
}));

export const getChecklistById = (id) => ALIGNER_CHECKLISTS.find(c => c.id === id);
